import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsEBikeRideNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M18 14.37a4.522 4.522 0 00-1.73.34l-1.59-3.04h1.46a.2.2 0 01.19.19v.48h1.35v-.48a1.531 1.531 0 00-1.54-1.53h-3.69l1.05 2H8.765L8.2 11.27h1.36l-.71-1.35h-4l.72 1.35h1.1l.56 1.055H2.25a.576.576 0 01-.575-.575v-6.5a.576.576 0 01.575-.575h9.15a3.175 3.175 0 003.1 2.5h2.18V6.132H19v-1.35h-2.32v-1.65H19v-1.35h-2.32V.83H14.5a3.175 3.175 0 00-3.1 2.5H2.25A1.926 1.926 0 00.325 5.25v6.5a1.926 1.926 0 001.925 1.925h5.677l-.5.935a4.667 4.667 0 103.166 5.27h1.22l2.77-5.48.52.99A4.66 4.66 0 1018 14.37zm-9.3.711l1.833 3.449H6.85zM6 22.371a3.324 3.324 0 11.778-6.547L5.27 18.62v.01l.65 1.25h3.286A3.323 3.323 0 016 22.371zm5.51-4.881l-2.033-3.82h3.953zM18 22.37a3.333 3.333 0 01-3.33-3.32 3.276 3.276 0 011.07-2.43l1.49 2.86h1.53l-1.86-3.57a3.3 3.3 0 011.1-.19 3.325 3.325 0 110 6.65z"
        fill=""
      />
    </svg>
  )
);
SvgSportsEBikeRideNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsEBikeRideNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsEBikeRideNormalSmall;
